import React from "react";

export const btnPrimary = "rounded-full px-4 py-2 text-sm text-[#000000] disabled:opacity-50 flex items-center justify-center gap-1.5";
export const gradient = { background: "linear-gradient(90deg,#FFFFFF,#C8C8C8)" };
export const inputCls = "rounded-xl bg-[#0D0D0D] border border-white/10 px-3 py-2 text-sm outline-none focus:border-mono-400/50 min-w-0";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");
export const usd = (n) => `$${Number(n || 0).toFixed(2)}`;

export function Card({ children, className = "", ...rest }) {
  return <div className={`rounded-2xl border border-white/10 bg-white/[0.03] p-4 ${className}`} {...rest}>{children}</div>;
}

export function Stat({ label, value, sub, testid }) {
  return (
    <Card data-testid={testid}>
      <div className="label-mono">{label}</div>
      <div className="text-2xl font-heading mt-1">{value}</div>
      {sub && <div className="text-xs text-slate-400 mt-0.5">{sub}</div>}
    </Card>
  );
}

export function Empty({ children = "Nothing here yet." }) {
  return <div className="text-sm text-slate-500 text-center py-8">{children}</div>;
}

export function Badge({ tone = "slate", children }) {
  const tones = { slate: "bg-white/5 text-slate-300", red: "bg-red-500/15 text-red-300", green: "bg-emerald-500/15 text-emerald-300", cyan: "bg-mono-400/15 text-mono-200", amber: "bg-amber-400/15 text-amber-200" };
  return <span className={`rounded-full px-2 py-0.5 text-[11px] ${tones[tone]}`}>{children}</span>;
}
